export const GB_UUID_COOKIE = 'GROWTHBOOK_DEVICE_ID'
